import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing222({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/222/1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/222/2.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/222/3.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/222/4.gif`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/222/5.png`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/orange/ApplyBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing222;
